// Default preview HTML used by the playground on first load.
// Example: it references classes generated by the default `.luis` sample.
export const defaultHtml = `<section class="card container-sm container-1">
  <h3 class="title if-demo">LentyStyle Playground Demo</h3>
  <p>This preview uses <code>@for</code> and <code>@if</code> generated classes.</p>

  <div class="m-2 density-compact">
    <button class="btn btn-primary-sm chip-1 tone-primary">Primary Small</button>
    <button class="btn btn-secondary-md chip-2 m-1">Secondary Medium</button>
    <button class="btn btn-danger-lg chip-3 m-2 tone-success">Danger Large</button>
  </div>

  <div class="grid-1-1 m-2">grid-1-1: nested loop output</div>
  <div class="grid-2-2 m-4">grid-2-2: nested loop output</div>

  <div class="class-1 m-1">class-1 from plain array</div>
  <div class="class-3-4 m-2">class-3-4 from quoted array values</div>
</section>`
